/**
 * §4 Business —— wf-business-section（全球收付款 3 卡）
 *
 * 需求来源：提示词 第1次提交（DEV-124229）；原型 L6175-6367。
 *
 * 注意事项：
 * 1. 标题下划线 .wf-business-heading-highlight::after 是本页**唯一的一次性**动画
 *    （wfBusinessUnderline 1.2s ease forwards，width 0→100%），加载即播、不重复。
 * 2. .wf-business-image-wrap 有 `overflow:hidden; border-radius:24px; background:#eeeeee`，
 *    圆角由容器负责 —— 这正是三张卡的图能从带 alpha 的 webp 转成 JPEG 的依据（见 images.js 注释第 4 条）。
 * 3. 卡片根元素用 <article>（与原型一致），语义上每张卡是独立内容块。
 */
import React from 'react';

export default function Business({ data }) {
  if (!data) return null;

  return (
    <section className="wf-business-section">
      <span className="wf-business-dot wf-business-dot--1" />
      <span className="wf-business-dot wf-business-dot--2" />

      <div className="wf-business-container">
        <h2 className="wf-business-heading">
          <span className="wf-business-heading-highlight">{data.heading}</span>
        </h2>
        <p className="wf-business-subtitle">{data.subtitle}</p>

        <div className="wf-business-grid">
          {(data.cards || []).map((c, i) => (
            <article className="wf-business-card" key={i}>
              <span className="wf-business-accent" />
              <h3 className="wf-business-card-title">{c.title}</h3>
              <ul className="wf-business-list">
                {(c.items || []).map((it, j) => (
                  <li key={j}>{it}</li>
                ))}
              </ul>
              <div className="wf-business-image-wrap">
                <img className="wf-business-image" src={c.imageUrl} alt={c.imageAlt} loading="lazy" />
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
